import { Box, Checkbox, FormControlLabel } from '@mui/material';
import type { ReactElement } from 'react';

import type { SlabDragControl } from '../../../SlabDraggableList/SlabDraggableList';
import type { Column } from '../../TableDataModel';
import { ColumnDragHandle } from './ColumnDragHandle';

type ColumnItemProps<TRow extends { id: string }> = {
  col: Column<TRow>;
  isChecked: boolean;
  dragControls: SlabDragControl;
  onColumnChange: (columnID: string, isRendered: boolean) => void;
  disableDnD: boolean;
};

export const ColumnItem = <TRow extends { id: string }>({
  col,
  dragControls,
  isChecked,
  onColumnChange,
  disableDnD,
}: ColumnItemProps<TRow>): ReactElement => (
  <Box display='flex' alignItems='center' paddingX='0.25rem' paddingY='0.25rem'>
    {disableDnD ? undefined : <ColumnDragHandle dragControls={dragControls} />}
    <FormControlLabel
      label={typeof col.label === 'function' ? col.label([]) : col.label}
      control={
        <Checkbox
          checked={isChecked}
          onChange={(_, checked): void => {
            onColumnChange(col.id, checked);
          }}
        />
      }
    />
  </Box>
);
